export default __webpack_public_path__ + "static/media/tecom-greens.b9331c10.webp";